import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getArenaSectionHeaderStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      paddingHorizontal: 4,
      paddingVertical: 4,
      marginBottom: 8,
      marginTop: 4,
    },
    accentBar: {
      width: 3,
      height: 18,
      borderRadius: 2,
    },
    accentBarUrgent: {
      backgroundColor: theme.primary,
    },
    accentBarLive: {
      backgroundColor: theme.error,
    },
    accentBarSoon: {
      backgroundColor: theme.info,
    },
    accentBarActive: {
      backgroundColor: theme.success,
    },
    accentBarIdle: {
      backgroundColor: theme.gray[500],
    },
    accentBarDone: {
      backgroundColor: theme.gray[500],
    },
    /** Title is inside the badge — matches design exactly */
    badge: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      paddingHorizontal: 9,
      paddingVertical: 3,
      borderRadius: 7,
    },
    badgeUrgent: {
      backgroundColor: theme.primary,
    },
    badgeLive: {
      backgroundColor: theme.error,
    },
    badgeSoon: {
      backgroundColor: theme.info,
    },
    badgeActive: {
      backgroundColor: theme.success,
    },
    badgeIdle: {
      backgroundColor: theme.gray[300],
    },
    badgeDone: {
      backgroundColor: theme.gray[300],
    },
    badgeTitle: {
      fontSize: 11,
      fontWeight: '800',
      letterSpacing: 0.4,
    },
    badgeTitleLight: {
      color: theme.onPrimary,
    },
    badgeTitleDark: {
      color: theme.gray[700],
    },
    badgeTitleStatus: {
      color: theme.textOnStatusBadge,
    },
    liveDot: {
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: theme.white,
    },
    count: {
      fontSize: 12,
      color: theme.gray[500],
      fontWeight: '600',
    },
  });

export function getArenaSectionHeaderIconColor(theme: Theme, textVariant: 'light' | 'dark' | 'status'): string {
  if (textVariant === 'dark') return theme.gray[700];
  if (textVariant === 'status') return theme.textOnStatusBadge;
  return theme.onPrimary;
}
